/**
 * @generated SignedSource<<0a2f523df295344186d354572ba7f902>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteInvoiceInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteInvoiceMutation$variables = {
  input: DeleteInvoiceInput;
};
export type deleteInvoiceMutation$data = {
  readonly deleteInvoice: {
    readonly deletedInvoiceId: string | null;
  } | null;
};
export type deleteInvoiceMutation = {
  variables: deleteInvoiceMutation$variables;
  response: deleteInvoiceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInvoicePayload",
    "kind": "LinkedField",
    "name": "deleteInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedInvoiceId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteInvoiceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteInvoiceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4166ec0d2316ccdb2f2fca4700bf6098",
    "id": null,
    "metadata": {},
    "name": "deleteInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation deleteInvoiceMutation(\n  $input: DeleteInvoiceInput!\n) {\n  deleteInvoice(input: $input) {\n    deletedInvoiceId\n  }\n}\n"
  }
};
})();

(node as any).hash = "da22f466466342677980c35efa598bda";

export default node;
